import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Link from 'next/link';
import { colors, screen } from 'components/styles/variables';

export function SubNavItem({ title, url }) {
  return (
    <li>
      <Link href={url}>
        <a>{title}</a>
      </Link>
      <style jsx>{`
        li {
          margin-right: 20px;
        }

        a {
          color: black;
        }

        a:hover {
          color: ${colors.ALR1};
        }
      `}</style>
    </li>
  );
}

SubNavItem.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
};

export function maybeRenderPricingAnalysis(hasPricingAnalysis, title, url) {
  if (hasPricingAnalysis) {
    return <SubNavItem title={title} url={url} />;
  }
  return null;
}

export default function SeoSrpSubNav({ article, searchUrl }) {
  const { t } = useTranslation();
  const hasPricingAnalysis = searchUrl.data.attributes.has_analysis;
  return (
    <section className="sub-nav">
      <div className="sub-nav-container">
        <h1 className="sub-nav-heading">{article.title}</h1>
        <ul className="sub-nav-list">
          <SubNavItem
            title={t('listingsSubNav.listings')}
            url={`/${article.parent_page.slug}`}
          />
          {maybeRenderPricingAnalysis(
            hasPricingAnalysis,
            t('listingsSubNav.pricingAnalysis'),
            `/${article.parent_page.slug}#section=pricing-analysis`
          )}
          <SubNavItem
            title={t('listingsSubNav.news')}
            url={`/${article.parent_page.slug}#section=news`}
          />
        </ul>
      </div>
      <style jsx>{`
        .sub-nav {
          border-top: 1px solid #ebebeb;
          padding: 15px;
        }

        @media (min-width: ${screen.smMin}) {
          .sub-nav {
            padding: 15px 10px;
          }
        }

        @media (min-width: ${screen.mdMin}) {
          .sub-nav {
            padding: 10px;
          }
        }

        .sub-nav-container {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-left: auto;
          margin-right: auto;
        }

        @media (min-width: ${screen.smMin}) {
          .sub-nav-container {
            width: 750px;
          }
        }

        @media (min-width: ${screen.mdMin}) {
          .sub-nav-container {
            width: 970px;
            flex-direction: row;
          }
        }

        @media (min-width: ${screen.lgMin}) {
          .sub-nav-container {
            width: 1170px;
          }
        }

        h1 {
          margin: 0;
          font-size: 21px;
        }

        @media (min-width: ${screen.smMin}) {
          h1 {
            font-size: 18px;
          }
        }

        ul {
          padding: 0;
          margin: 6px 0px 0px 0px;
          display: flex;
          list-style: none;
        }

        @media (min-width: ${screen.smMin}) {
          ul {
            margin: 0;
          }
        }
      `}</style>
    </section>
  );
}

SeoSrpSubNav.propTypes = {
  article: PropTypes.object.isRequired,
  searchUrl: PropTypes.object.isRequired,
};
